import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { FiPhoneCall } from "react-icons/fi";
import orderImage from "../assets/images/svgs/cards/orders.svg";
import { GoSun, GoMoon } from "react-icons/go";
import { SlCalender } from "react-icons/sl";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import UploadRow from "../components/upload/UploadRow";
import uploadIcon from "../assets/images/svgs/other/uploadImg.svg";
import InputBase from "../components/form/inputs/InputBase";
import PrimaryBtn from "../components/button/PrimaryBtn";
import SecondaryBtn from "../components/button/SecondaryBtn";
import Successicon from "../assets/images/svgs/other/success.svg";
import SuccessSwal from "../components/Swals/SuccessSwal";
import Collectpay from "../components/Modals/Collectpay";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { uploadPhoto } from "../redux/thunks/registerThunks.js";
import { clearOrderDraft } from "../redux/slices/orderDraftSlice.js";
import {
  addOrupdateDeliverAnOrder,
  getCustomerDataDeliverAnOrder,
} from "../redux/thunks/orderCustomerThunk";
import DeliveryIcon from "../assets/images/svgs/cards/delivery.svg";
import { Copy, SquareArrowOutUpRight } from "lucide-react";
import MapModal from "../components/Modals/MapModal.jsx";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId, encryptId } from "../utils/urlCrypto.js";
import ImagePreview from "../components/ui/ImagePreview.jsx";
import OrderDeliveryShimmer from "../components/Preloader/OrderDeliveryShimmer.jsx";

const Orderdelivery = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isDetailOpen, setIsDetailsOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [mealDetails, setMealDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [isPayopen, setIsPayopen] = useState(false);
  const [isMapOpen, setIsMapOpen] = useState(false);
  const { orderId } = useParams();
  const order_id = decryptId(orderId);
  const { isOrderLoading, isCustomerDataLoading } = useSelector(
    (state) => state.customerOrder,
  );
  const [paymentType, setPaymentType] = useState(null);
  const [notes, setNotes] = useState("");
  const [Curr, setCurr] = useState("");

  useEffect(() => {
    const payload = {
      order_id: order_id,
    };
    dispatch(getCustomerDataDeliverAnOrder(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of data is :", res.data);
        const getDetails = res.data;
        setMealDetails(getDetails);
        const getCur = res.data?.currency_symbol;
        setCurr(getCur);
      });
  }, [dispatch]);

  const onEditClick = (orderId) => {
    navigate(`/edit-order/${encryptId(orderId)}`);
  };
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleRemoveImage = () => {
    if (preview) {
      URL.revokeObjectURL(preview);
      setPreview(null);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const deliverOrder = async (type) => {
    try {
      let uploadedFileName = null;

      if (imageFile) {
        const formData = new FormData();
        formData.append("type", "orders/delivery_proofs");
        formData.append("image", imageFile);

        const uploadRes = await dispatch(uploadPhoto(formData)).unwrap();
        uploadedFileName = uploadRes?.data?.temp_image_name || null;
      }

      const payload = {
        order_id: order_id,
        service_provider_customer_id: mealDetails?.customer?.customer_id,
        order_payment_type: type,
        remark: notes,
        order_deliver_proof_image: uploadedFileName,
      };

      const res = await dispatch(addOrupdateDeliverAnOrder(payload)).unwrap();

      if (!res?.success) {
        toast.error(res?.message || "Failed to deliver");
        return false;
      }

      // toast.success(res.message);
      dispatch(clearOrderDraft());

      return true;
    } catch (err) {
      toast.error(err?.message || "Fail to deliver");
      return false;
    }
  };

  const handleDeliverOrder = async (type) => {
    // 👉 PAYMENT NOW
    if (type === "now") {
      setIsPayopen(true); // open modal ONLY
      return;
    }

    // 👉 PAYMENT LATER
    const success = await deliverOrder("later");

    if (success) {
      setOpen(true); // success swal
    }
  };

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const address = mealDetails?.customer?.addresses?.[0];
  // Payment calculations
  const orderAmount = Number(mealDetails?.order_amount || 0);
  const availableBalance = Number(mealDetails?.customer?.current_balance || 0);

  // due calculation
  const dueAmount =
    availableBalance < orderAmount ? orderAmount - availableBalance : 0;

  const hasEnoughBalance = availableBalance >= orderAmount;

  return (
    <>
      {/* {isOrderLoading ? (
        <OrderdetailShimmer />
      ) : ( */}
      <section className="relative min-h-screen max-w-7xl mx-auto  bg-slate-50">
        <DecorativeSquares />
        <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
          <button
            onClick={handleGoBack}
            className="flex items-center p-2 rounded-full hover:bg-gray-100"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="mx-auto text-2xl font-semibold text-gray-900">
            Deliver an Order
          </h1>
        </div>
        {/* Center Card Wrapper */}
        <div className="px-4 mt-8">
          <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
            <div className="flex flex-col md:flex-row justify-between gap-4 ">
              <div className="flex items-center gap-4">
                {/* Avatar */}
                <div className="flex items-center justify-center w-12 h-12 rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                  {getInitials(mealDetails?.customer?.customer_name)}
                </div>

                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {mealDetails?.customer?.customer_name}
                  </h2>

                  <p className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                    <FiPhoneCall /> +{mealDetails?.customer?.country_code}{" "}
                    {mealDetails?.customer?.customer_contact_no}
                  </p>
                </div>
              </div>
              <div className="inline-flex justify-between items-center gap-2 bg-[#FF6943]/15 text-[#FF6943] px-3 py-2.5 rounded-full text-xs font-semibold shadow-sm border border-[#FF6943]/20">
                <span>#{mealDetails?.order_unique_id}</span>

                <Copy
                  size={14}
                  className="cursor-pointer hover:text-[#ff6b00] transition"
                  onClick={() => {
                    if (!mealDetails?.order_unique_id) return;

                    navigator.clipboard.writeText(mealDetails.order_unique_id);
                    toast.success("Order ID copied!");
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Main details */}
        <div className="px-4 mt-8">
          <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
            <div className="flex items-center gap-4">
              {/* Avatar */}
              <div className="flex items-center justify-center  rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                <ImagePreview
                  src={mealDetails?.meal?.meal_cover_image}
                  alt={"dish"}
                  className="object-cover w-12 h-12 rounded-md"
                />
              </div>

              {/* User Info */}
              <div className="flex flex-col">
                <h2 className="text-base font-semibold text-gray-900">
                  {mealDetails?.meal?.meal_name || "Unknown Meal"}
                </h2>

                <p className="mt-1 flex items-center gap-2 text-sm text-[#FF6943] font-bold">
                  {Curr} {Number(mealDetails?.price_per_meal).toFixed(2)}
                </p>
              </div>
            </div>
            <div
              className={`rounded-full  w-24 p-1 px-2 flex justify-center mt-4 items-center gap-2 ${mealDetails?.meal_timing === "dinner" ? "bg-[#B472FF]/10" : "bg-[#FF6943]/10"}`}
            >
              {mealDetails?.meal_timing === "lunch" ? (
                <GoSun size={12} className="text-[#FF6943] font-medium" />
              ) : (
                <GoMoon size={12} className="text-purple-800 font-medium" />
              )}
              <p
                className={`text-xs font-medium  ${mealDetails?.meal_timing === "dinner" ? "text-purple-800" : "text-[#FF6943]"}`}
              >
                {mealDetails?.meal_timing}
              </p>
            </div>

            <div className="border-b border-gray-200 mt-6 mb-2"></div>
            <div className="flex justify-between">
              <p className="text-gray-900 text-base font-semibold">
                Order details
              </p>
              {isDetailOpen ? (
                <button
                  className="mt-1 cursor-pointer duration-500 ease-in-out transition-all"
                  onClick={() => setIsDetailsOpen(false)}
                >
                  <MdKeyboardArrowUp />
                </button>
              ) : (
                <button
                  className="mt-1 cursor-pointer duration-500 ease-in-out transition-all"
                  onClick={() => setIsDetailsOpen(true)}
                >
                  <MdKeyboardArrowDown />
                </button>
              )}
            </div>
            {isDetailOpen && (
              <>
                <div className="mt-4">
                  {/* Order header */}
                  <div className="flex justify-between gap-4">
                    <div className="flex gap-4">
                      <img
                        src={orderImage}
                        alt={mealDetails?.meal?.meal_name}
                        className="h-5 w-5 "
                      />
                      <p className="text-gray-900 text-sm font-medium text-start">
                        {mealDetails?.quantity} x {mealDetails?.meal?.meal_name}
                      </p>
                    </div>
                    <button
                      onClick={() => onEditClick(mealDetails?.order_id)}
                      className="border border-gray-200 p-2 rounded-md cursor-pointer"
                    >
                      <CiEdit />
                    </button>
                  </div>
                  {/* Order details */}
                  <div className="relative -mx-4 sm:mx-0 overflow-x-auto mt-4">
                    <div className="w-full md:min-w-[640px] rounded-lg border border-gray-200 bg-white">
                      <table className="w-full text-left text-sm sm:text-base text-gray-800">
                        {/* Header */}
                        <thead className="bg-gray-50">
                          {mealDetails?.extra_items?.length > 0 && (
                            <tr>
                              <th
                                colSpan={2}
                                className="py-3 px-4 text-start text-base sm:text-lg font-semibold"
                              >
                                Extra items
                              </th>
                              <th
                                colSpan={2}
                                className="py-3 px-4 text-end text-base sm:text-lg font-semibold text-[#FF6943]"
                              >
                                {Curr}
                                {Number(mealDetails?.extra_total).toFixed(2)}
                              </th>
                            </tr>
                          )}
                        </thead>

                        {/* Body */}
                        <tbody className="divide-y">
                          {mealDetails?.extra_items?.length > 0 &&
                            mealDetails?.extra_items.map((item, i) => (
                              <tr key={i}>
                                <td colSpan={2} className="py-2 px-4">
                                  <div className="flex items-center gap-2 whitespace-nowrap">
                                    <span className="inline-block w-2 h-2 rounded-full bg-[#FF6943]" />
                                    <span>{`${item.quantity} x ${item.name}`}</span>
                                  </div>
                                </td>
                                <td className="py-2 px-4 text-end font-semibold whitespace-nowrap">
                                  {Curr}
                                  {Number(item.amount).toFixed(2)}
                                </td>
                              </tr>
                            ))}

                          {/* Charges */}
                          {mealDetails.delivery_type === "delivery" && (
                            <tr className="bg-gray-50">
                              <th
                                colSpan={2}
                                className="py-3 px-4 font-semibold"
                              >
                                Delivery charges
                              </th>
                              <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                                {Curr}
                                {Number(mealDetails?.delivery_charges).toFixed(
                                  2,
                                )}
                              </th>
                            </tr>
                          )}
                          {(() => {
                            const rawValue = Number(
                              mealDetails?.discount_and_other_charges || 0,
                            );
                            const isDiscount = rawValue < 0;

                            return (
                              <>
                                {mealDetails?.discount_and_other_charges ===
                                0 ? null : (
                                  <tr>
                                    <th
                                      colSpan={2}
                                      className="py-3 px-4 font-semibold"
                                    >
                                      {isDiscount
                                        ? "Discount"
                                        : "Other Charges"}
                                    </th>

                                    <th
                                      className={`py-3 px-4 text-end font-semibold ${
                                        isDiscount
                                          ? "text-[#1CCB50]"
                                          : "text-red-500"
                                      }`}
                                    >
                                      {isDiscount ? `- ${Curr}` : `+${Curr}`}
                                      {Math.abs(rawValue).toFixed(2)}
                                    </th>
                                  </tr>
                                )}
                              </>
                            );
                          })()}

                          <tr className="bg-orange-50">
                            <th
                              colSpan={2}
                              className="py-3 px-4 font-semibold text-[#FF6943]"
                            >
                              Total Order Amount
                            </th>
                            <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                              {Curr}
                              {Number(mealDetails?.order_amount).toFixed(2)}
                            </th>
                          </tr>
                        </tbody>

                        {/* Footer */}
                        <tfoot className="border-t bg-white">
                          <tr>
                            <th colSpan={2} className="py-3 px-4 font-medium">
                              Plan Type
                            </th>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-end font-semibold"
                            >
                              {mealDetails?.meal_plan_type}
                            </th>
                          </tr>
                          <tr>
                            <th colSpan={2} className="py-3 px-4 font-medium">
                              Start Date
                            </th>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-end font-semibold"
                            >
                              {mealDetails?.order_date}
                            </th>
                          </tr>
                          <tr>
                            <th colSpan={2} className="py-3 px-4 font-medium">
                              Meal Timing
                            </th>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-end font-semibold"
                            >
                              {mealDetails?.meal_timing && (
                                <div className="flex justify-end items-center gap-2">
                                  {mealDetails.meal_timing.toLowerCase() ===
                                  "lunch" ? (
                                    <GoSun size={17} className="font-bold" />
                                  ) : (
                                    <GoMoon size={17} className="font-bold" />
                                  )}

                                  <span className="capitalize">
                                    {mealDetails.meal_timing}
                                  </span>
                                </div>
                              )}
                            </th>
                          </tr>
                          <tr>
                            <th colSpan={2} className="py-3 px-4 font-medium">
                              Delivery Type
                            </th>

                            <td
                              colSpan={2}
                              className="py-3 px-4 text-end font-semibold"
                            >
                              {mealDetails?.delivery_type && (
                                <div className="flex justify-end items-center gap-2">
                                  <img
                                    src={DeliveryIcon}
                                    alt="delivery icon"
                                    className="h-4 w-4 object-contain"
                                  />

                                  <span className="capitalize">
                                    {mealDetails?.delivery_type === "delivery"
                                      ? "Home Delivery"
                                      : "Pick Up"}
                                  </span>
                                </div>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th colSpan={2} className="py-3 px-4 font-medium">
                              Time slot
                            </th>
                            {mealDetails?.time_slot ? (
                              <th
                                colSpan={2}
                                className="py-3 px-4 text-end font-semibold"
                              >
                                {mealDetails?.time_slot}
                              </th>
                            ) : (
                              <th
                                colSpan={2}
                                className="py-3 px-4 text-end font-semibold"
                              >
                                -
                              </th>
                            )}
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  {/* Address */}
                  {mealDetails?.delivery_type === "delivery" && (
                    <div
                      onClick={() => setIsMapOpen(true)}
                      className="mt-4 flex justify-start items-center gap-2 cursor-pointer hover:text-blue-600 transition"
                    >
                      <CiLocationOn size={20} className="text-[#FF6943]" />
                      <p className="text-start text-[#FF6943] text-[12px] md:text-sm">
                        {mealDetails.customer.addresses[0].address_1}
                      </p>
                      <SquareArrowOutUpRight
                        size={15}
                        className="text-[#FF6943] text-end"
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Delivery proof */}
        <div className="px-4 mt-8">
          <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
            <h2 className="text-base font-semibold text-gray-900">
              Capture Delivery Proof
            </h2>
            <div className="w-full mt-2">
              <UploadRow
                id="delivery-proof-upload"
                icon={uploadIcon}
                onChange={handleImageUpload}
              />
            </div>

            {/* Image Preview */}
            {preview && (
              <div className="mt-4">
                <div className="relative inline-block">
                  {/* Image */}
                  <img
                    src={preview}
                    alt="Delivery Proof"
                    className="w-28 h-32 object-cover border border-gray-200 rounded-xl"
                  />

                  {/* Remove Button */}
                  <button
                    onClick={handleRemoveImage}
                    className="absolute -top-2 -right-2 bg-black/70 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-black transition"
                    title="Remove image"
                  >
                    ✕
                  </button>
                </div>
              </div>
            )}
            <div className="mt-6">
              <InputBase
                label="Delivery Remark"
                name="notes"
                type="textarea"
                placeholder="Remarks"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
            <SuccessSwal
              open={open}
              icon={
                <img src={Successicon} alt="success" className="h-16 w-16" />
              }
              title="Your order has been delivered successfully."
              description="Let's work towards the next order."
              buttonText="Continue"
              onConfirm={handleGoBack}
              onClose={() => setOpen(false)}
            />
          </div>
          <Collectpay
            amountCut={
              mealDetails?.customer?.balance_type === "advance"
                ? dueAmount
                : null
            }
            open={isPayopen}
            onClose={() => setIsPayopen(false)}
            orderId={order_id}
            onDeliver={deliverOrder}
          />

          <MapModal
            isOpen={isMapOpen}
            onClose={() => setIsMapOpen(false)}
            address={address}
            actualAddress={address?.address_1}
          />
        </div>
        {mealDetails?.customer?.balance_type === "advance" && (
          <div className="px-4 mt-8">
            <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">
                Payment Summary
              </h2>

              <div className="space-y-3 text-sm">
                {/* Available Balance */}
                <div className="flex justify-between text-gray-600">
                  <span>Available Balance</span>
                  <span className="font-semibold">
                    {Curr} {availableBalance.toFixed(2)}
                  </span>
                </div>

                {/* To be paid */}
                <div className="flex justify-between text-gray-600">
                  <span>To be Paid</span>
                  <span className="font-semibold">
                    {Curr} {orderAmount.toFixed(2)}
                  </span>
                </div>

                {/* Divider */}
                <div className="border-t border-dashed border-gray-300 my-2"></div>

                {/* Due Amount */}
                <div className="flex justify-between font-semibold text-base">
                  <span>Due Amount</span>
                  <span
                    className={
                      dueAmount > 0
                        ? "text-red-500 font-bold"
                        : "text-green-600 font-bold"
                    }
                  >
                    {Curr} {dueAmount.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="px-4 mt-8 mb-8">
          <div className="flex justify-center items-center flex-wrap gap-4 md:justify-between mt-4">
            {mealDetails?.customer?.balance_type === "advance" ? (
              hasEnoughBalance ? (
                <PrimaryBtn
                  btnName="Deliver Now"
                  clickEvent={() => handleDeliverOrder("later")}
                  isLoading={isOrderLoading}
                />
              ) : (
                <>
                  <PrimaryBtn
                    btnName="Collect Payment Now"
                    clickEvent={() => handleDeliverOrder("now")}
                    isLoading={isOrderLoading}
                  />

                  <SecondaryBtn
                    btnName="Collect Payment Later"
                    clickEvent={() => handleDeliverOrder("later")}
                    isLoading={isOrderLoading}
                  />
                </>
              )
            ) : (
              <>
                <PrimaryBtn
                  btnName="Collect Payment Now"
                  clickEvent={() => handleDeliverOrder("now")}
                  isLoading={isOrderLoading}
                />

                <SecondaryBtn
                  btnName="Collect Payment Later"
                  clickEvent={() => handleDeliverOrder("later")}
                  isLoading={isOrderLoading}
                />
              </>
            )}
          </div>
        </div>
      </section>
      {/* )} */}
    </>
  );
};

export default Orderdelivery;
